import { JsonProperty } from 'json-typescript-mapper';

export class GeoEntity {

  @JsonProperty('id')
  public id?: number;

  @JsonProperty('accuracy')
  public accuracy?: number;

  @JsonProperty('altitude')
  public altitude?: number | null;

  @JsonProperty('altitudeAccuracy')
  public altitudeAccuracy?: number | null;

  @JsonProperty('heading')
  public heading?: number | null;

  @JsonProperty('latitude')
  public latitude?: number;

  @JsonProperty('longitude')
  public longitude?: number;

  @JsonProperty('speed')
  public speed?: number | null;

  @JsonProperty('timestamp')
  public timestamp?: number;

  @JsonProperty('manual')
  public manual?: boolean;

  constructor() {
    this.id = void 0;
    this.accuracy = void 0;
    this.altitude = void 0;
    this.altitudeAccuracy = void 0;
    this.heading = void 0;
    this.latitude = void 0;
    this.longitude = void 0;
    this.speed = void 0;
    this.timestamp = void 0;
    this.manual = void 0;
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/geo-entity.model.ts